document.addEventListener('DOMContentLoaded', function () {
  const collectionProducts = document.querySelector('#product-grid');
  const loadMoreButton = document.querySelector('.load-more__btn');
  const loadingSpinner = document.querySelector('.load-more__spinner');

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function () {
      loadMoreButton.classList.add('hidden');
      loadingSpinner.classList.remove('hidden');

      let nextUrl = loadMoreButton.getAttribute('data-next-url');

      if (nextUrl) {
        fetch(nextUrl, { method: 'GET' })
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newProducts = doc.querySelector('#product-grid').innerHTML;
            collectionProducts.insertAdjacentHTML('beforeend', newProducts);

            // Update data-index and animation-order for newly loaded products
            const newProductItems = collectionProducts.querySelectorAll('.grid__item');
            const urlParams = new URLSearchParams(nextUrl);
            const startPosition = parseInt(urlParams.get('position')) || 0;

            newProductItems.forEach((item, index) => {
              const newPosition = startPosition + index + 1;
              item.setAttribute('data-index', newPosition);
              if (item.style.getPropertyValue('--animation-order')) {
                item.style.setProperty('--animation-order', newPosition);
              }
            });

            // Reinitialize Trustpilot widget only for newly loaded products
            const newTrustpilotWidgets = collectionProducts.querySelectorAll('.trustpilot-widget:has(a)');
            newTrustpilotWidgets.forEach((widget) => {
              Trustpilot.loadFromElement(widget);
            });

            loadMoreButton.classList.remove('hidden');
            loadingSpinner.classList.add('hidden');

            // next url logic
            const newNextUrl = doc.querySelector('.load-more__btn')?.getAttribute('data-next-url');
            if (newNextUrl) {
              loadMoreButton.setAttribute('data-next-url', newNextUrl);
            } else {
              loadMoreButton.remove();
            }
          })
          .catch((error) => console.error('Error loading more products:', error));
      }
    });
  }
});
